import React, { Fragment } from 'react'
import Drawer from '@mui/material/Drawer'
import NavMenu from './NavMenu'

const MobileNav = props => {
    const { open, onClose } = props

    return (
        <Fragment>
            <Drawer
                variant="temporary"
                anchor="left"
                open={open}
                onClose={onClose}
            >
                <NavMenu />
            </Drawer>
        </Fragment>
    )
}

export default MobileNav
